<template>
  <div class="employee-page">
    <div class="page-header">
      <span>员工管理</span>
      <el-button class="fr addBtn" type="primary" @click="handleAdd">添加员工</el-button>
    </div>
    <div class="table-card">
      <z-table
        keep-scroll-pos
        v-loading="loading"
        ref="EmployeeListable"
        :data="employeeList"
        :columns="columns"
        :pagination.sync="pagination"
        @page-change="handlePageChange"
        :height="tableHeight"
        size="mini"
        :selection="true"
        @selection-change="handleSelectionChange"
      >
        <template #status="{ row }">
          {{ row.status ? '启用' : '停用' }}
        </template>
        <template #operation="{ row }">
          <el-button @click="handleEdit(row.userId)" type="text" size="small">编辑</el-button>
          <el-button type="text" size="small" @click="() => handleDelete(row.userId)">删除</el-button>
        </template>
      </z-table>
    </div>
    <Dialog :title="title" :vstatus="vstatus" ref="empDialog" @getEmps="getEmployee"></Dialog>
  </div>
</template>

<script>
import { delEmpByConditions, getEmployees } from '../../server/employee'
import Dialog from './component/dialog'
import { LIST_COLUMN } from './config'
export default {
  name: 'EmployeeList',
  data() {
    return {
      loading: false,
      employeeList: [],
      show: false,
      tableHeight: null,
      columns: LIST_COLUMN,
      pagination: {
        pageNum: 1, // 页码
        pageSize: 10, // 每页大小
        total: 0
      },
      title: '',
      vstatus: false
    }
  },
  components: {
    Dialog
  },
  mounted() {
    this.getEmployee()
  },
  methods: {
    /**
     * 获取员工列表
     */
    async getEmployee() {
      this.loading = true
      let reqData = {
        pageNum: this.pagination.pageNum,
        pageSize: this.pagination.pageSize
      }
      const { data } = await getEmployees(reqData)
      if (data.code === this.$code) {
        this.employeeList = data.data.items
        this.pagination.total = data.data.totalCount
      }
      this.loading = false
    },
    /**
     * 分页功能
     */
    handlePageChange() {
      this.getEmployee()
    },
    handleSelectionChange() {
      // 单选框触发
      console.log('handleSelectionChange')
    },
    /**
     * 删除员工
     */
    handleDelete(userId) {
      this.$confirm('确定删除吗，删除后将不能找回，请慎重操作', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(async () => {
          const { data } = await delEmpByConditions(userId)
          if (data.code === this.$code) {
            this.$message({
              type: 'success',
              message: this.$t('system::tip::delete_success')
            })
            this.getEmployee()
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    /**
     * 弹层显示
     * 参数说明：带参为编辑员工，不带参为添加员工
     */
    async handleEdit(userId) {
      this.title = '编辑员工'
      this.vstatus = true
      this.$refs.empDialog.handleVisible(userId)
    },
    handleAdd() {
      this.title = '添加员工'
      this.vstatus = false
      this.$refs.empDialog.handleVisible()
    }
  }
}
</script>

<style lang="scss" scoped>
.fl {
  float: left;
}
.fr {
  float: right;
}
.employee-page {
  box-sizing: border-box;
  .page-header {
    margin-bottom: 20px;
    display: flex;
    margin-bottom: 20px;
    align-items: center;
    justify-content: space-between;
    span {
      font-size: 18px;
    }
    .addBtn {
      color: #fff;
      border-radius: 5px;
    }
  }
  .table-card {
    background: #fff;
    border-radius: 12px;
    box-sizing: border-box;
    padding-bottom: 16px;
    overflow: hidden;
    .operation-item {
      // margin-left: 10px;
      color: $--color-primary;
      display: block;
      width: 16px;
      height: 16px;
      margin-left: 8px;
      margin-bottom: 10px;
      cursor: pointer;
    }
  }
  /deep/ .el-dialog {
    width: 35%;
    .el-dialog__body {
      padding: 0;
    }
    .el-form {
      padding: 24px 100px;
      .formTip {
        margin-top: 20px;
        i {
          color: #ff8e40;
          font-size: 16px;
        }
        span {
          margin-left: 20px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ff8e40;
          line-height: 20px;
        }
      }
    }
    .dialogBtn {
      border-radius: 6px;
      padding: 8px 36px;
      width: 120px;
      height: 32px;
    }
    .dialog-footer {
      text-align: center;
    }
  }
}
</style>
